import React from 'react';
import { Helmet } from 'react-helmet-async';

const StructuredData = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    "name": "Smart Educare Center",
    "alternateName": "Smart Educare Centre",
    "description": "Premium preschool and daycare center offering personalized coaching, sanskar varg, and counseling services in Badlapur",
    "url": "https://smarteducarecentre.vercel.app",
    "telephone": "+91-9834387679",
    "email": "centresmarteducare@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Shop No. 7, Parshuram Plaza, opposite classmate cafe",
      "addressLocality": "Katrap, Badlapur",
      "addressRegion": "Maharashtra",
      "postalCode": "421503",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "19.1704",
      "longitude": "73.2673"
    },
    "openingHours": "Mo-Sa 08:00-18:00",
    "priceRange": "$$",
    "image": "https://smarteducarecentre.vercel.app/logo512.png",
    "founder": {
      "@type": "Person",
      "name": "Rohini Kharade",
      "jobTitle": "Prime Mover"
    },
    "areaServed": {
      "@type": "Place",
      "name": "Badlapur, Maharashtra, India"
    },
    "serviceType": [
      "Preschool Education",
      "Daycare Services", 
      "Personalized Coaching",
      "Sanskar Varg",
      "Counseling Services"
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "50"
    }
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Smart Educare Center",
    "image": "https://smarteducarecentre.vercel.app/logo512.png",
    "telephone": "+91-9834387679",
    "email": "centresmarteducare@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Shop No. 7, Parshuram Plaza, opposite classmate cafe",
      "addressLocality": "Katrap, Badlapur",
      "addressRegion": "Maharashtra",
      "postalCode": "421503",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "19.1704",
      "longitude": "73.2673"
    },
    "url": "https://smarteducarecentre.vercel.app",
    "openingHours": "Mo-Sa 08:00-18:00",
    "priceRange": "$$"
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Smart Educare Center",
    "url": "https://smarteducarecentre.vercel.app",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://smarteducarecentre.vercel.app/?s={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://smarteducarecentre.vercel.app"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Services",
        "item": "https://smarteducarecentre.vercel.app/#services"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Courses",
        "item": "https://smarteducarecentre.vercel.app/#courses"
      },
      {
        "@type": "ListItem",
        "position": 4,
        "name": "Gallery",
        "item": "https://smarteducarecentre.vercel.app/#gallery"
      },
      {
        "@type": "ListItem",
        "position": 5,
        "name": "About",
        "item": "https://smarteducarecentre.vercel.app/#about"
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
